import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const LongBalanceChart = ({ data }) => {
  const [ChartState, setChartState] = useState({
    series: [
      {
        name: "Trades per day",
        type: "area",
        data: [],
      },
    ],
    options: {
      colors: ["#04D9FF"],
      fill: {
        colors: "#04D9FF",
        type: "gradient",
        gradient: {
          type: "vertical",
          shadeIntensity: 0,
          gradientToColors: undefined,
          opacityFrom: 0.7,
          opacityTo: 0.2,
          stops: [0, 90, 100],
        },
      },
      legend: {
        fontSize: "14px",
        fontWeight: 700,
        labels: {
          colors: "white",
        },
        markers: {
          width: 15,
          height: 15,
        },
      },
      chart: {
        fontFamily: "Outfit, sans-serif",
        toolbar: {
          show: false,
        },
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 4,
      },
      grid: {
        borderColor: "#415672",
        strokeDashArray: 8,
      },
      xaxis: {
        seriesName: "Trades",
        title: {
          text: "Trades",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        categories: [],
        tooltip: {
          enabled: false,
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: {
          rotate: -45,
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
      yaxis: [
        {
          seriesName: "Balance",
          title: {
            text: "Balance",
            style: {
              fontSize: 14,
              fontWeight: 700,
              color: "#ffffff",
            },
          },
          labels: {
            style: {
              colors: "#8B8E93",
              fontSize: "12px",
            },
          },
        },

        // type: 'datetime',
      ],
      tooltip: {
        enabled: false,
      },
    },
  });

  useEffect(() => {
    if (data) {
      setChartState({
        series: [
          {
            name: "Profit",
            type: "area",
            data: data.balance,
          },
        ],
        options: {
          ...ChartState.options,
          xaxis: {
            ...ChartState.options.xaxis,
            categories: data.number_of_trades,
          },
        },
      });
    }
  }, [data]);

  return (
    <div id="chart">
      <ReactApexChart
        options={ChartState.options}
        series={ChartState.series}
        height={250}
      />
    </div>
  );
};
export default LongBalanceChart;
